import { VideoTranscriber } from "@/components/VideoTranscriber";

export default function VideoTranscriberPage() {
  return <VideoTranscriber />;
}